

































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Revenue, revenueStatuses, IRevenue } from '@/services/models'
import { Action, Getter } from 'vuex-class'

import CustomerSelector from '@/components/CustomerSelector.vue'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    CustomerSelector,
  },
})
export default class EditRevenueModal extends Vue {

  @Action('firestore/writeRevenue')
  private writeRevenue!: (revenue: Revenue) => Promise<Revenue>

  private isModalOpen: boolean = false

  private title: string = ''

  private localCopy: Revenue = new Revenue()

  private formatters = formatters

  private get statusOptions(): string[] {
    return revenueStatuses
  }

  public async _commit(value: Revenue, buttonEvent: any) {
    // Validate
    console.log('Committed!!', buttonEvent)

    // Invoke API
    await this.writeRevenue(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Revenue) {
    // emit!
  }

  // PUBLIC Interface

  public edit(data: IRevenue) {
    this.show()
    this.title = `Edit Revenue: ${data.id}`
    throw new Error('Implementation is reqired.')
  }

  public create() {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Revenue'
    this.localCopy = new Revenue()
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
